













import { Component, Vue } from "vue-property-decorator";
import AllocationTypeEdit from "@/views/admin/budget/AllocationType.vue";
import BudgetEdit from "@/views/admin/budget/Budget.vue";

const components = {
    AllocationTypeEdit,
    BudgetEdit,
};

@Component({ components })
export default class AdminTabs extends Vue {

}
